import { post, urlApiTegra } from "../../../../../../service/api";

export function sendFeedback(token: string, body: any) {
  return post(`${urlApiTegra}/send-feedback`, body, token);
}
